/**
 * Длительность коммуникации из metadata адаптера приёма (сек).
 *
 * Чистый модуль без зависимостей: им пользуются и клиент meerec (карточка
 * звонка), и маппер карточки встречи.
 */

/**
 * Источники длительности: `[путь в metadata, делитель до секунд]`. Порядок =
 * приоритет — зеркало бэкенда (`meerec.srv.bc` →
 * `colver/core/communications/duration.py`, `DURATION_SOURCES`), чтобы карточка
 * показывала то же число, что лента и «Минуты».
 *
 * `durationSeconds` при приёме измеряется по самому файлу записи — совпадает с
 * плеером. Провайдерские поля — fallback, если формат файла не распознан: это
 * длительность вызова, часто вместе с гудками/IVR. Plaud — в миллисекундах.
 */
const DURATION_SOURCES: ReadonlyArray<
  readonly [path: string, divisor: number]
> = [
  ['durationSeconds', 1],
  ['duration', 1],
  ['mts.duration', 1],
  ['megafon.duration', 1],
  ['telfin.bridged_duration', 1],
  ['telfin.duration', 1],
  ['domru.duration', 1],
  ['domoplaner.duration', 1],
  ['rostelecom.duration', 1],
  ['qstats.durationSeconds', 1],
  ['colver.duration', 1],
  ['colver.billSec', 1],
  ['colver.durationSec', 1],
  ['plaud.duration', 1000],
];

/** Значение по dot-пути внутри metadata (`mts.duration`). */
const valueAt = (metadata: Record<string, unknown>, path: string): unknown => {
  let node: unknown = metadata;
  for (const key of path.split('.')) {
    if (!node || typeof node !== 'object' || Array.isArray(node))
      return undefined;
    node = (node as Record<string, unknown>)[key];
  }
  return node;
};

/** Длительность из metadata, сек: первый источник с конечным неотрицательным числом. */
export const extractDurationSeconds = (
  metadata: Record<string, unknown>,
): number | null => {
  for (const [path, divisor] of DURATION_SOURCES) {
    const v = valueAt(metadata, path);
    if (typeof v === 'number' && Number.isFinite(v) && v >= 0)
      return v / divisor;
  }
  return null;
};
